import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = () => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        content_name: 'El Permiso',
        content_type: 'product',
        value: 7.0,
        currency: 'EUR'
      });
    }
    onClick?.();
    window.open('https://www.tubienestarinterno.com/cart/53225995501905:1', '_blank');
  };
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-130">
      <motion.button whileHover={{
      scale: 1.01
    }} whileTap={{
      scale: 0.99
    }} onClick={handleClick} className="w-full sm:w-auto bg-navy hover:bg-navy-dark text-white font-sans font-semibold py-4 px-8 rounded-lg shadow-sm hover:shadow-md transition-all duration-200 text-base md:text-lg" data-id="element-131">
        Descargar ahora (7€)
      </motion.button>
      <p className="mt-3 text-xs md:text-sm text-gray font-medium tracking-wide" data-id="element-132">
        Pago seguro · Acceso inmediato · Sin suscripción
      </p>
    </div>;
}